"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import { YMaps, Map as YMap } from "@pbe/react-yandex-maps";
import "./style.css";

export default function YandexMap({
  items = [],
  apiKey,
  width = "70%",        // desktop default
  height = 700,         // desktop default (px)
  mobileWidth = "100%", // mobile default
  mobileHeight = 700,   // mobile default (px)
  defaultCenter = [55.751244, 37.618423],
  defaultZoom = 10,
}) {
  const mapRef = useRef(null);
  const [ymapsRef, setYmapsRef] = useState(null);
  const [points, setPoints] = useState([]);

  const processItems = useCallback(() => {
    const seen = new Set();
    const uniquePoints = items
      .filter((item) => {
        if (!item || !item.coords) {
          console.warn("Item without coords:", item);
          return false;
        }
        const key = `${item.coords[0]}:${item.coords[1]}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((item, index) => ({
        id: index,
        coords: item.coords,
        item,
      }));
    setPoints(uniquePoints);
  }, [items]);

  useEffect(() => {
    processItems();
  }, [processItems]);

  useEffect(() => {
    if (!ymapsRef || !mapRef.current) return;
    const map = mapRef.current;

    if (!map.__clusterer) {
      map.__clusterer = new ymapsRef.Clusterer({
        preset: "islands#invertedBlueClusterIcons",
        clusterDisableClickZoom: false,
        clusterOpenBalloonOnClick: true,
        maxZoom: 18,
      });
      map.geoObjects.add(map.__clusterer);
    }

    const clusterer = map.__clusterer;
    clusterer.removeAll();

    const placemarks = points.map(
      (p) =>
        new ymapsRef.Placemark(
          p.coords,
          {
            hintContent: p.item.brand
              ? `${p.item.brand} — ${p.item.city ?? ""}`
              : p.item.city ?? "",
            balloonContent: `<strong>${p.item.brand ?? ""}</strong><br/>${
              p.item.city ?? ""
            }<br/>${p.item.address}`,
          },
          { preset: "islands#blueCircleDotIcon" },
        ),
    );

    if (placemarks.length) clusterer.add(placemarks);
  }, [points, ymapsRef]);

  // Управляем размерами через CSS-переменные, чтобы media-query переопределил на мобиле
  const containerStyle = {
    "--map-width": width,
    "--map-height": typeof height === "number" ? `${height}px` : height,
    "--map-mobile-width": mobileWidth,
    "--map-mobile-height":
      typeof mobileHeight === "number" ? `${mobileHeight}px` : mobileHeight,
  };

  return (
    <div className="yandexMap" style={containerStyle}>
      <div className="yandexMap__inner" style={{minWidth: "100%"}}>
        <YMaps
          query={{
            ...(apiKey ? { apikey: apiKey } : {}),
            lang: "ru_RU",
            load: "package.full",
          }}
        >
          <YMap
            defaultState={{ center: defaultCenter, zoom: defaultZoom }}
            instanceRef={mapRef}
            onLoad={(ymaps) => setYmapsRef(ymaps)}
            width="100%"   /* заполняем обёртку */
            height="100%"  /* заполняем обёртку */
            modules={[
              "Placemark",
              "Clusterer",
              "geoObject.addon.hint",
              "geoObject.addon.balloon",
            ]}
          />
        </YMaps>
      </div>
    </div>
  );
}
